import AcademicCap from './AcademicCapIcon';
import Adjustments from './AdjustmentsIcon';
import Annotation from './AnnotationIcon';
import Archive from './ArchiveIcon';
import ArrowCircleDown from './ArrowCircleDownIcon';
import ArrowCircleLeft from './ArrowCircleLeftIcon';
import ArrowCircleRight from './ArrowCircleRightIcon';
import ArrowCircleUp from './ArrowCircleUpIcon';
import ArrowDown from './ArrowDownIcon';
import ArrowLeft from './ArrowLeftIcon';
import ArrowNarrowDown from './ArrowNarrowDownIcon';
import ArrowNarrowLeft from './ArrowNarrowLeftIcon';
import ArrowNarrowRight from './ArrowNarrowRightIcon';
import ArrowNarrowUp from './ArrowNarrowUpIcon';
import ArrowRight from './ArrowRightIcon';
import ArrowUp from './ArrowUpIcon';
import ArrowsExpand from './ArrowsExpandIcon';
import AtSymbol from './AtSymbolIcon';
import Backspace from './BackspaceIcon';
import BadgeCheck from './BadgeCheckIcon';
import Ban from './BanIcon';
import Beaker from './BeakerIcon';
import Bell from './BellIcon';
import BookOpen from './BookOpenIcon';
import BookmarkAlt from './BookmarkAltIcon';
import Bookmark from './BookmarkIcon';
import Briefcase from './BriefcaseIcon';
import Cake from './CakeIcon';
import Calculator from './CalculatorIcon';
import Calendar from './CalendarIcon';
import Camera from './CameraIcon';
import Cash from './CashIcon';
import ChartBar from './ChartBarIcon';
import ChartPie from './ChartPieIcon';
import ChartSquareBar from './ChartSquareBarIcon';
import ChatAlt2 from './ChatAlt2Icon';
import ChatAlt from './ChatAltIcon';
import Chat from './ChatIcon';
import CheckCircle from './CheckCircleIcon';
import Check from './CheckIcon';
import ChevronDoubleDown from './ChevronDoubleDownIcon';
import ChevronDoubleLeft from './ChevronDoubleLeftIcon';
import ChevronDoubleRight from './ChevronDoubleRightIcon';
import ChevronDoubleUp from './ChevronDoubleUpIcon';
import ChevronDown from './ChevronDownIcon';
import ChevronLeft from './ChevronLeftIcon';
import ChevronRight from './ChevronRightIcon';
import ChevronUp from './ChevronUpIcon';
import Chip from './ChipIcon';
import ClipboardCheck from './ClipboardCheckIcon';
import ClipboardCopy from './ClipboardCopyIcon';
import ClipboardList from './ClipboardListIcon';
import Clipboard from './ClipboardIcon';
import Clock from './ClockIcon';
import CloudDownload from './CloudDownloadIcon';
import CloudUpload from './CloudUploadIcon';
import Cloud from './CloudIcon';
import Code from './CodeIcon';
import Cog from './CogIcon';
import Collection from './CollectionIcon';
import ColorSwatch from './ColorSwatchIcon';
import CreditCard from './CreditCardIcon';
import CubeTransparent from './CubeTransparentIcon';
import Cube from './CubeIcon';
import CurrencyBangladeshi from './CurrencyBangladeshiIcon';
import CurrencyDollar from './CurrencyDollarIcon';
import CurrencyEuro from './CurrencyEuroIcon';
import CurrencyPound from './CurrencyPoundIcon';
import CurrencyRupee from './CurrencyRupeeIcon';
import CurrencyYen from './CurrencyYenIcon';
import CursorClick from './CursorClickIcon';
import Database from './DatabaseIcon';
import DesktopComputer from './DesktopComputerIcon';
import DeviceMobile from './DeviceMobileIcon';
import DeviceTablet from './DeviceTabletIcon';
import DocumentAdd from './DocumentAddIcon';
import DocumentDownload from './DocumentDownloadIcon';
import DocumentDuplicate from './DocumentDuplicateIcon';
import DocumentRemove from './DocumentRemoveIcon';
import DocumentReport from './DocumentReportIcon';
import DocumentSearch from './DocumentSearchIcon';
import DocumentText from './DocumentTextIcon';
import Document from './DocumentIcon';
import DotsCircleHorizontal from './DotsCircleHorizontalIcon';
import DotsHorizontal from './DotsHorizontalIcon';
import DotsVertical from './DotsVerticalIcon';
import Download from './DownloadIcon';
import Duplicate from './DuplicateIcon';
import EmojiHappy from './EmojiHappyIcon';
import EmojiSad from './EmojiSadIcon';
import ExclamationCircle from './ExclamationCircleIcon';
import Exclamation from './ExclamationIcon';
import ExternalLink from './ExternalLinkIcon';
import EyeOff from './EyeOffIcon';
import Eye from './EyeIcon';
import FastForward from './FastForwardIcon';
import Film from './FilmIcon';
import Filter from './FilterIcon';
import FingerPrint from './FingerPrintIcon';
import Fire from './FireIcon';
import Flag from './FlagIcon';
import FolderAdd from './FolderAddIcon';
import FolderDownload from './FolderDownloadIcon';
import FolderOpen from './FolderOpenIcon';
import FolderRemove from './FolderRemoveIcon';
import Folder from './FolderIcon';
import Gift from './GiftIcon';
import GlobeAlt from './GlobeAltIcon';
import Globe from './GlobeIcon';
import Hand from './HandIcon';
import Hashtag from './HashtagIcon';
import Heart from './HeartIcon';
import Home from './HomeIcon';
import Identification from './IdentificationIcon';
import InboxIn from './InboxInIcon';
import Inbox from './InboxIcon';
import InformationCircle from './InformationCircleIcon';
import Key from './KeyIcon';
import Library from './LibraryIcon';
import LightBulb from './LightBulbIcon';
import LightningBolt from './LightningBoltIcon';
import Link from './LinkIcon';
import LocationMarker from './LocationMarkerIcon';
import LockClosed from './LockClosedIcon';
import LockOpen from './LockOpenIcon';
import Login from './LoginIcon';
import Logout from './LogoutIcon';
import MailOpen from './MailOpenIcon';
import Mail from './MailIcon';
import Map from './MapIcon';
import MenuAlt1 from './MenuAlt1Icon';
import MenuAlt2 from './MenuAlt2Icon';
import MenuAlt3 from './MenuAlt3Icon';
import MenuAlt4 from './MenuAlt4Icon';
import Menu from './MenuIcon';
import Microphone from './MicrophoneIcon';
import MinusCircle from './MinusCircleIcon';
import MinusSm from './MinusSmIcon';
import Minus from './MinusIcon';
import Moon from './MoonIcon';
import MusicNote from './MusicNoteIcon';
import Newspaper from './NewspaperIcon';
import OfficeBuilding from './OfficeBuildingIcon';
import PaperAirplane from './PaperAirplaneIcon';
import PaperClip from './PaperClipIcon';
import Pause from './PauseIcon';
import PencilAlt from './PencilAltIcon';
import Pencil from './PencilIcon';
import PhoneIncoming from './PhoneIncomingIcon';
import PhoneMissedCall from './PhoneMissedCallIcon';
import PhoneOutgoing from './PhoneOutgoingIcon';
import Phone from './PhoneIcon';
import Photograph from './PhotographIcon';
import Play from './PlayIcon';
import PlusCircle from './PlusCircleIcon';
import PlusSm from './PlusSmIcon';
import Plus from './PlusIcon';
import PresentationChartBar from './PresentationChartBarIcon';
import PresentationChartLine from './PresentationChartLineIcon';
import Printer from './PrinterIcon';
import Puzzle from './PuzzleIcon';
import Qrcode from './QrcodeIcon';
import QuestionMarkCircle from './QuestionMarkCircleIcon';
import ReceiptRefund from './ReceiptRefundIcon';
import ReceiptTax from './ReceiptTaxIcon';
import Refresh from './RefreshIcon';
import Reply from './ReplyIcon';
import Rewind from './RewindIcon';
import Rss from './RssIcon';
import SaveAs from './SaveAsIcon';
import Save from './SaveIcon';
import Scale from './ScaleIcon';
import Scissors from './ScissorsIcon';
import SearchCircle from './SearchCircleIcon';
import Search from './SearchIcon';
import Selector from './SelectorIcon';
import Server from './ServerIcon';
import Share from './ShareIcon';
import ShieldCheck from './ShieldCheckIcon';
import ShieldExclamation from './ShieldExclamationIcon';
import ShoppingBag from './ShoppingBagIcon';
import ShoppingCart from './ShoppingCartIcon';
import SortAscending from './SortAscendingIcon';
import SortDescending from './SortDescendingIcon';
import Sparkles from './SparklesIcon';
import Speakerphone from './SpeakerphoneIcon';
import Star from './StarIcon';
import StatusOffline from './StatusOfflineIcon';
import StatusOnline from './StatusOnlineIcon';
import Stop from './StopIcon';
import Sun from './SunIcon';
import Support from './SupportIcon';
import SwitchHorizontal from './SwitchHorizontalIcon';
import SwitchVertical from './SwitchVerticalIcon';
import Table from './TableIcon';
import Tag from './TagIcon';
import Template from './TemplateIcon';
import Terminal from './TerminalIcon';
import ThumbDown from './ThumbDownIcon';
import ThumbUp from './ThumbUpIcon';
import Ticket from './TicketIcon';
import Translate from './TranslateIcon';
import Trash from './TrashIcon';
import TrendingDown from './TrendingDownIcon';
import TrendingUp from './TrendingUpIcon';
import Truck from './TruckIcon';
import Upload from './UploadIcon';
import UserAdd from './UserAddIcon';
import UserCircle from './UserCircleIcon';
import UserGroup from './UserGroupIcon';
import UserRemove from './UserRemoveIcon';
import User from './UserIcon';
import Users from './UsersIcon';
import Variable from './VariableIcon';
import VideoCamera from './VideoCameraIcon';
import ViewBoards from './ViewBoardsIcon';
import ViewGridAdd from './ViewGridAddIcon';
import ViewGrid from './ViewGridIcon';
import ViewList from './ViewListIcon';
import VolumeOff from './VolumeOffIcon';
import VolumeUp from './VolumeUpIcon';
import Wifi from './WifiIcon';
import XCircle from './XCircleIcon';
import X from './XIcon';
import ZoomIn from './ZoomInIcon';
import ZoomOut from './ZoomOutIcon';

export type OutlineType = 'AcademicCap' | 'Adjustments' | 'Annotation' | 'Archive' | 'ArrowCircleDown' | 'ArrowCircleLeft' | 'ArrowCircleRight' | 'ArrowCircleUp' | 'ArrowDown' | 'ArrowLeft' | 'ArrowNarrowDown' | 'ArrowNarrowLeft' | 'ArrowNarrowRight' | 'ArrowNarrowUp' | 'ArrowRight' | 'ArrowUp' | 'ArrowsExpand' | 'AtSymbol' | 'Backspace' | 'BadgeCheck' | 'Ban' | 'Beaker' | 'Bell' | 'BookOpen' | 'BookmarkAlt' | 'Bookmark' | 'Briefcase' | 'Cake' | 'Calculator' | 'Calendar' | 'Camera' | 'Cash' | 'ChartBar' | 'ChartPie' | 'ChartSquareBar' | 'ChatAlt2' | 'ChatAlt' | 'Chat' | 'CheckCircle' | 'Check' | 'ChevronDoubleDown' | 'ChevronDoubleLeft' | 'ChevronDoubleRight' | 'ChevronDoubleUp' | 'ChevronDown' | 'ChevronLeft' | 'ChevronRight' | 'ChevronUp' | 'Chip' | 'ClipboardCheck' | 'ClipboardCopy' | 'ClipboardList' | 'Clipboard' | 'Clock' | 'CloudDownload' | 'CloudUpload' | 'Cloud' | 'Code' | 'Cog' | 'Collection' | 'ColorSwatch' | 'CreditCard' | 'CubeTransparent' | 'Cube' | 'CurrencyBangladeshi' | 'CurrencyDollar' | 'CurrencyEuro' | 'CurrencyPound' | 'CurrencyRupee' | 'CurrencyYen' | 'CursorClick' | 'Database' | 'DesktopComputer' | 'DeviceMobile' | 'DeviceTablet' | 'DocumentAdd' | 'DocumentDownload' | 'DocumentDuplicate' | 'DocumentRemove' | 'DocumentReport' | 'DocumentSearch' | 'DocumentText' | 'Document' | 'DotsCircleHorizontal' | 'DotsHorizontal' | 'DotsVertical' | 'Download' | 'Duplicate' | 'EmojiHappy' | 'EmojiSad' | 'ExclamationCircle' | 'Exclamation' | 'ExternalLink' | 'EyeOff' | 'Eye' | 'FastForward' | 'Film' | 'Filter' | 'FingerPrint' | 'Fire' | 'Flag' | 'FolderAdd' | 'FolderDownload' | 'FolderOpen' | 'FolderRemove' | 'Folder' | 'Gift' | 'GlobeAlt' | 'Globe' | 'Hand' | 'Hashtag' | 'Heart' | 'Home' | 'Identification' | 'InboxIn' | 'Inbox' | 'InformationCircle' | 'Key' | 'Library' | 'LightBulb' | 'LightningBolt' | 'Link' | 'LocationMarker' | 'LockClosed' | 'LockOpen' | 'Login' | 'Logout' | 'MailOpen' | 'Mail' | 'Map' | 'MenuAlt1' | 'MenuAlt2' | 'MenuAlt3' | 'MenuAlt4' | 'Menu' | 'Microphone' | 'MinusCircle' | 'MinusSm' | 'Minus' | 'Moon' | 'MusicNote' | 'Newspaper' | 'OfficeBuilding' | 'PaperAirplane' | 'PaperClip' | 'Pause' | 'PencilAlt' | 'Pencil' | 'PhoneIncoming' | 'PhoneMissedCall' | 'PhoneOutgoing' | 'Phone' | 'Photograph' | 'Play' | 'PlusCircle' | 'PlusSm' | 'Plus' | 'PresentationChartBar' | 'PresentationChartLine' | 'Printer' | 'Puzzle' | 'Qrcode' | 'QuestionMarkCircle' | 'ReceiptRefund' | 'ReceiptTax' | 'Refresh' | 'Reply' | 'Rewind' | 'Rss' | 'SaveAs' | 'Save' | 'Scale' | 'Scissors' | 'SearchCircle' | 'Search' | 'Selector' | 'Server' | 'Share' | 'ShieldCheck' | 'ShieldExclamation' | 'ShoppingBag' | 'ShoppingCart' | 'SortAscending' | 'SortDescending' | 'Sparkles' | 'Speakerphone' | 'Star' | 'StatusOffline' | 'StatusOnline' | 'Stop' | 'Sun' | 'Support' | 'SwitchHorizontal' | 'SwitchVertical' | 'Table' | 'Tag' | 'Template' | 'Terminal' | 'ThumbDown' | 'ThumbUp' | 'Ticket' | 'Translate' | 'Trash' | 'TrendingDown' | 'TrendingUp' | 'Truck' | 'Upload' | 'UserAdd' | 'UserCircle' | 'UserGroup' | 'UserRemove' | 'User' | 'Users' | 'Variable' | 'VideoCamera' | 'ViewBoards' | 'ViewGridAdd' | 'ViewGrid' | 'ViewList' | 'VolumeOff' | 'VolumeUp' | 'Wifi' | 'XCircle' | 'X' | 'ZoomIn' | 'ZoomOut';

export default {
	AcademicCap,
	Adjustments,
	Annotation,
	Archive,
	ArrowCircleDown,
	ArrowCircleLeft,
	ArrowCircleRight,
	ArrowCircleUp,
	ArrowDown,
	ArrowLeft,
	ArrowNarrowDown,
	ArrowNarrowLeft,
	ArrowNarrowRight,
	ArrowNarrowUp,
	ArrowRight,
	ArrowUp,
	ArrowsExpand,
	AtSymbol,
	Backspace,
	BadgeCheck,
	Ban,
	Beaker,
	Bell,
	BookOpen,
	BookmarkAlt,
	Bookmark,
	Briefcase,
	Cake,
	Calculator,
	Calendar,
	Camera,
	Cash,
	ChartBar,
	ChartPie,
	ChartSquareBar,
	ChatAlt2,
	ChatAlt,
	Chat,
	CheckCircle,
	Check,
	ChevronDoubleDown,
	ChevronDoubleLeft,
	ChevronDoubleRight,
	ChevronDoubleUp,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronUp,
	Chip,
	ClipboardCheck,
	ClipboardCopy,
	ClipboardList,
	Clipboard,
	Clock,
	CloudDownload,
	CloudUpload,
	Cloud,
	Code,
	Cog,
	Collection,
	ColorSwatch,
	CreditCard,
	CubeTransparent,
	Cube,
	CurrencyBangladeshi,
	CurrencyDollar,
	CurrencyEuro,
	CurrencyPound,
	CurrencyRupee,
	CurrencyYen,
	CursorClick,
	Database,
	DesktopComputer,
	DeviceMobile,
	DeviceTablet,
	DocumentAdd,
	DocumentDownload,
	DocumentDuplicate,
	DocumentRemove,
	DocumentReport,
	DocumentSearch,
	DocumentText,
	Document,
	DotsCircleHorizontal,
	DotsHorizontal,
	DotsVertical,
	Download,
	Duplicate,
	EmojiHappy,
	EmojiSad,
	ExclamationCircle,
	Exclamation,
	ExternalLink,
	EyeOff,
	Eye,
	FastForward,
	Film,
	Filter,
	FingerPrint,
	Fire,
	Flag,
	FolderAdd,
	FolderDownload,
	FolderOpen,
	FolderRemove,
	Folder,
	Gift,
	GlobeAlt,
	Globe,
	Hand,
	Hashtag,
	Heart,
	Home,
	Identification,
	InboxIn,
	Inbox,
	InformationCircle,
	Key,
	Library,
	LightBulb,
	LightningBolt,
	Link,
	LocationMarker,
	LockClosed,
	LockOpen,
	Login,
	Logout,
	MailOpen,
	Mail,
	Map,
	MenuAlt1,
	MenuAlt2,
	MenuAlt3,
	MenuAlt4,
	Menu,
	Microphone,
	MinusCircle,
	MinusSm,
	Minus,
	Moon,
	MusicNote,
	Newspaper,
	OfficeBuilding,
	PaperAirplane,
	PaperClip,
	Pause,
	PencilAlt,
	Pencil,
	PhoneIncoming,
	PhoneMissedCall,
	PhoneOutgoing,
	Phone,
	Photograph,
	Play,
	PlusCircle,
	PlusSm,
	Plus,
	PresentationChartBar,
	PresentationChartLine,
	Printer,
	Puzzle,
	Qrcode,
	QuestionMarkCircle,
	ReceiptRefund,
	ReceiptTax,
	Refresh,
	Reply,
	Rewind,
	Rss,
	SaveAs,
	Save,
	Scale,
	Scissors,
	SearchCircle,
	Search,
	Selector,
	Server,
	Share,
	ShieldCheck,
	ShieldExclamation,
	ShoppingBag,
	ShoppingCart,
	SortAscending,
	SortDescending,
	Sparkles,
	Speakerphone,
	Star,
	StatusOffline,
	StatusOnline,
	Stop,
	Sun,
	Support,
	SwitchHorizontal,
	SwitchVertical,
	Table,
	Tag,
	Template,
	Terminal,
	ThumbDown,
	ThumbUp,
	Ticket,
	Translate,
	Trash,
	TrendingDown,
	TrendingUp,
	Truck,
	Upload,
	UserAdd,
	UserCircle,
	UserGroup,
	UserRemove,
	User,
	Users,
	Variable,
	VideoCamera,
	ViewBoards,
	ViewGridAdd,
	ViewGrid,
	ViewList,
	VolumeOff,
	VolumeUp,
	Wifi,
	XCircle,
	X,
	ZoomIn,
	ZoomOut
};